import {
  FETCH_INVENTORY_REPORT,
  FETCH_INVENTORY_REPORT_SUCCESS,
  FETCH_INVENTORY_REPORT_FAIL,
} from './actionTypes';

const INIT_STATE = {
  inventoryReport: null,
  inventoryReportLoading: false,
  inventoryReportError: null,
};

const ReportingInventory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_INVENTORY_REPORT:
      return { ...state, inventoryReportLoading: true, inventoryReportError: null };
    case FETCH_INVENTORY_REPORT_SUCCESS:
      return {
        ...state,
        inventoryReport: action.payload,
        inventoryReportLoading: false,
        inventoryReportError: null,
      };
    case FETCH_INVENTORY_REPORT_FAIL:
      return {
        ...state,
        inventoryReport: null,
        inventoryReportLoading: false,
        inventoryReportError: action.payload,
      };
    default:
      return state;
  }
};

export default ReportingInventory;
